import React, { useState, useEffect } from 'react';
import axios from 'axios';
  import translations from '../../utils/language/translations.json'
  import { useTranslation } from 'react-i18next';
  import { toast } from 'react-toastify';
const OutputField = ({cards,userId }) => {

   const { t: translate, i18n } = useTranslation();
    const currentLang = i18n.language;
    const t = (key) => translations.Export[key][currentLang];
  const [inputValue, setInputValue] = useState('');
    const [checkbox1, setCheckbox1] = useState(false);
    const [checkboxCADUSD, setCheckboxCADUSD] = useState(false);
    const [checkboxBO, setCheckboxBO] = useState(false);
    const [checkboxLinks,setCheckboxLinks] = useState(false);
    const [dropdownOptionsTradeTemplate, setDropdownOptionsTradeTemplate] = useState([]);
    const [dropdownOptionsTypeOfPost, setDropdownOptionsTypeOfPost] = useState(['For Sale or Trade','For Sale Only','For Trade Only']);
    const [allOptionTradeTemplate, setAllOptionTradeTemplate] = useState([])
    const [selectedOptionTradeTemplate, setSelectedOptionTradeTemplate] = useState('');
    const [selectedOptionTypeOfPost, setSelectedOptionTypeOfPost] = useState('');
    const [links,setLinks]=useState([])
    const [priceOrEstimate,setPriceOrEstimate]=useState(false)
  // Use useEffect to update inputValue when cards prop changes

  useEffect(() => {
    const assignTitleToTemplates = () => {
      const formattedOptions = allOptionTradeTemplate.map((option) => ({
        value: option.TradingPreferencesId,
        label: option.TemplateTitle, // Assuming 'TemplateTitle' is the title property in your data
      }));
      setDropdownOptionsTradeTemplate(formattedOptions);
    };
  
    // Call the function to assign titles to templates
    assignTitleToTemplates();
  }, [allOptionTradeTemplate]);

  useEffect(() => {
    // Format card data for input
    console.log(dropdownOptionsTradeTemplate)
     // Predefined values based on checkboxes
     let predefinedValues = '';
     
    
     if (checkboxCADUSD) {
       predefinedValues += '-------------(USD)-------------- \n';
     }
     else {
      predefinedValues += '-------------(CAD)-------------- \n';
     }
 
    
     if (selectedOptionTypeOfPost) {
      predefinedValues += `${selectedOptionTypeOfPost}\n`;
    }

    if (checkboxBO) {
      predefinedValues += `\n ${t("Best Offer Allowed")}  \n`;
    }

if (selectedOptionTypeOfPost === 'For Sale or Trade' || selectedOptionTypeOfPost === 'For Trade Only') {
     predefinedValues += `-------------${t("My wish list(Trade)")}-- \n `;

  // Assuming you have these values available in your state
  if (selectedOptionTradeTemplate) {
    // Add PlayerName
    
    if (selectedOptionTradeTemplate.TypeOfCard)
    predefinedValues += ` Type      : ${selectedOptionTradeTemplate.TypeOfCard}  \n`;
    predefinedValues += ` Player    : ${selectedOptionTradeTemplate.PlayerNames}  \n`;
    
    // Add Set
    predefinedValues += ` Set       : ${selectedOptionTradeTemplate.SetNames}  \n`;

    // Add Attribute (if available)
    if (selectedOptionTradeTemplate.isOnlyAuto||selectedOptionTradeTemplate.isRookie||selectedOptionTradeTemplate.isOnlyRPA||selectedOptionTradeTemplate.Number||selectedOptionTradeTemplate.isOnlyTrueRookie) {
    predefinedValues += ` Attribute : ${selectedOptionTradeTemplate.isOnlyTrueRookie ? '(OnlyTrueRookie)' : ''}${selectedOptionTradeTemplate.isRookie ? '(OnlyRookie)' : ''}${selectedOptionTradeTemplate.isOnlyRPA ? '(OnlyRPA)' : ''}${selectedOptionTradeTemplate.isOnlyAuto ? '(OnlyAuto)' : ''}${selectedOptionTradeTemplate.Number ? '(OnlyNumberedCard)' : ''}   \n`;
    }
    if (selectedOptionTradeTemplate.CardNames)
    {
    predefinedValues += ` Card      : ${selectedOptionTradeTemplate.CardNames}  \n`;
    }
    // Add Variation (if available)
    if (selectedOptionTradeTemplate.VariationNames) {
    predefinedValues += ` Variation : ${selectedOptionTradeTemplate.VariationNames}  \n`;
    }

    if (selectedOptionTradeTemplate.OtherDetails) {
    predefinedValues += ` ${t('Other')}     : ${selectedOptionTradeTemplate.OtherDetails}  \n`;
    }
  }
} 
     predefinedValues +=`-------------${t("My Cards")}------------  \n`
    const formattedCardData = cards.map((card,index) => {
        return `${index+1}-${card.Name} ${card.cardName} ${card.variationName} ${card.isRookie === 1 ? '(RC)' : ''}${card.isAuto === 1 ? '(Auto)' : ''}${
          card.isPatch === 1 ? '(Patch)' : ''
        }${card.isJersey === 1 ? '(Jersey)' : ''}\n ${card.SetName}  ${card.Graded === 0 ? `${card.ConditionCard}` : `${card.GradeCompany}${card.Grade},`
        }   ${priceOrEstimate === true ?  ` ~ ${card.Price}` : `${card.EstimateValue}`}$`;
      });

      const shippingPrice=`${t("Shipping Regular")} 3$  -  ${t("With Tracking")} 15$ - ${t("Insured with tracking")} 30$`
     
      let linksIsShown = `${t("My Links")}  \n ${links.EbayProfile?('(ebay)'+links.EbayProfile):''}${links.ComC?('(ComC)'+links.ComC):''}${links.InstagramProfile?('(Instagram)'+links.InstagramProfile):''}`
      if(!checkboxLinks)
      {linksIsShown=''}
      
      setInputValue(predefinedValues + formattedCardData.join('\n') + '\n' + '\n' + shippingPrice +'\n'+'\n'+ linksIsShown);
      
  }, [cards, checkbox1, checkboxCADUSD, checkboxBO,selectedOptionTypeOfPost,selectedOptionTradeTemplate,priceOrEstimate]);

  useEffect(() => {

      // Replace this with your actual API call
      const fetchTradingPreferencesOptions = async () => {
        try {
          const response = await axios.get(`${process.env.REACT_APP_API_BASE}/api/get/trading-preferences/${userId}`, {
            params: { userId },   
        withCredentials: true, // ✅ sends cookies/session
      
          });

         await setAllOptionTradeTemplate(response.data);
          console.log(allOptionTradeTemplate) // Store the entire response data in playerOptions state
        } catch (error) {
          console.log('Error fetching player options:', error.message);
        }
      };
  
    // Call the function to fetch dropdown options
    fetchTradingPreferencesOptions();
  }
  
  , []);


  useEffect(() => {
      
      // Replace this with your actual API call
      const fetchProfilLinks = async () => {
        try {
          const response = await axios.get(`${process.env.REACT_APP_API_BASE}/api/get/links/${userId}`, {
            params: { userId },   
        withCredentials: true, // ✅ sends cookies/session
      
          });

         await setLinks(response.data);
         

          console.log(links) // Store the entire response data in playerOptions state
        } catch (error) {
          console.log('Error fetching user links :', error.message);
        }
      };
  
    // Call the function to fetch dropdown options
    fetchProfilLinks();
  }
  
  , [checkboxLinks]);

  const handleCopyToClipboard = () => {
    // Create a new textarea element to copy the text
    const textarea = document.createElement('textarea');
    textarea.value = inputValue;
    document.body.appendChild(textarea);

    // Select the text in the textarea
    textarea.select();

    // Copy the selected text to the clipboard
    document.execCommand('copy');

    // Remove the temporary textarea element
    document.body.removeChild(textarea);

    // Notify the user that the text has been copied
    toast.success(t("Text copied to clipboard")
  
  );
  };

  const handleChangeTradeTemplate = (event) => {
    const selectedValue = event.target.value;
    // Find the selected template based on its value
  
    console.log(allOptionTradeTemplate)
    const selectedTemplate = allOptionTradeTemplate.find((template) => parseInt(template.TradingPreferencesId) === parseInt(selectedValue));
    setSelectedOptionTradeTemplate(selectedTemplate);
 
  };

  return (
    <div className="export-form">
      {/* Dropdown for Type of Post */}
      <div className='flex-h' style={{paddingBottom:'0px'}}>
      <div className="form-group">
        <label>{t("Type of post (For Sale - For Trade)")}</label>
        <select
          value={selectedOptionTypeOfPost}
          onChange={(e) => setSelectedOptionTypeOfPost(e.target.value)}
          className="styled-select"
        >
          <option value="">{t("Select an option")}</option>
          {dropdownOptionsTypeOfPost.map((option) => (
            <option key={option} value={option}>
              {t(`${option}`)}
            </option>
          ))}
        </select>
        </div>
        {selectedOptionTypeOfPost==='For Sale or Trade'||selectedOptionTypeOfPost==='For Trade Only' ?
        (<div className="form-group">
        <label>{t("Trade Template (Player - Set - Etc)")}</label>
        <select
          onChange={handleChangeTradeTemplate}
          className="styled-select"
        >
          <option value="">{t("Select an option")}</option>
          {dropdownOptionsTradeTemplate.map((option) => (
            <option key={option.value} value={option.value}>
              {option.label}
            </option>
          ))}
        </select>
   </div>
         ):null}
   </div>

   
<div className="export-options">
<label className="toggle-label">
          {t("Price in USD (CAD by default)")}
          <label className="toggle-switch">
            <input
              type="checkbox"
              checked={checkboxCADUSD}
              onChange={() => setCheckboxCADUSD(!checkboxCADUSD)}
            />
            <span className="slider"></span>
          </label>
        </label>

        <label className="toggle-label">
          {t("Best Offer")}
          <label className="toggle-switch">
            <input
              type="checkbox"
              checked={checkboxBO}
              onChange={() => setCheckboxBO(!checkboxBO)}
            />
            <span className="slider"></span>
          </label>
        </label>


        <label className="toggle-label">
        {t("Estimate Value")}
          <label className="toggle-switch">
            <input
              type="checkbox"
              checked={priceOrEstimate}
              onChange={() => setPriceOrEstimate(!priceOrEstimate)}
            />
            <span className="slider Active"></span>
           
          </label>
          {t('Price')}
        </label>
    

</div>

      {/* Dropdown for Trade Template */}
      

      {/* Textarea for Output */}
      <div className="form-group">

        <textarea
          rows="10"
          className="styled-textarea"
          value={inputValue}
          onChange={(e) => setInputValue(e.target.value)}
        />
      </div>

      {/* Toggle Switch for Showing Links */}
      <div className="form-group">
        <label className="toggle-label">
        {t("Show my Links (Ebay, ComC, Instagram)")}
          <label className="toggle-switch">
            <input
              type="checkbox"
              checked={checkboxLinks}
              onChange={() => setCheckboxLinks(!checkboxLinks)}
            />
            <span className="slider"></span>
          </label>
        </label>
      </div>

      {/* Copy to Clipboard Button */}
      <button className="btn-baseBlue" onClick={handleCopyToClipboard}>
        {t("Copy to Clipboard")}
      </button>
    </div>
  );
};

export default OutputField;
